<template>
  <div>
    <label v-if="label" class="block text-xs font-medium mb-1 text-gray-500">{{ label }}</label>
    <input
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :type="type"
      :placeholder="placeholder"
      class="border border-gray-200 rounded px-2 py-1.5 text-sm focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-all hover:border-gray-400"
    />
  </div>
</template>

<script>
export default {
  name: 'FilterInput',
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
}
</script>
